import { render, staticRenderFns } from "./VsPromoCode.vue?vue&type=template&id=5f164fe4&scoped=true&"
import script from "./VsPromoCode.vue?vue&type=script&lang=js&"
export * from "./VsPromoCode.vue?vue&type=script&lang=js&"
import style0 from "./VsPromoCode.vue?vue&type=style&index=0&id=5f164fe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f164fe4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VTextField})
